/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { createBrowserHistory } from 'history';
import Axios from 'axios';

// project imports
import { ACCESS_TOKEN, REFRESH_TOKEN, setToken, unsetToken, getToken, getPayload, isTokenExpired, setAccessToken } from './token';
import { getAdminUrl, getAdminHeaders } from 'shared/http';
import { tokenrefresh, admindetail, sellertoken,buyertoken } from 'shared/settings/apiconfig';
import toast from 'shared/toast';
import store from 'features/store';

/* sets token for the newly logged in user */
export async function login(token) {
    // sets the user token in local storage
    setToken(token);

    // get seller token
    await getSellerToken();

    //get buyertoken
    await getbuyerToken();

    // call the user api to set user detail in app
    await setUser();
}

/* removes user token on logout or expiry */
export function logout(history, navigate = true) {
    // unset user from app
    store.dispatch({ type: 'SET_USER', payload: {} });

    // clears the new access token get call interval
    if (store.getState()['refreshInterval']) {
        clearInterval(store.getState()['refreshInterval']);
    }

    // clears token details from local storage
    unsetToken();

    if (navigate) {
        history.push('/');
    }
}

async function getSellerToken() {
    await Axios.get(getAdminUrl(sellertoken), getAdminHeaders())
        .then(response => {
            store.dispatch({
                type: 'SET_SELLER_TOKEN',
                payload: response.data['accessToken']
            });
        })
        .catch(error => {
            toast.error(error.response?.data['message'] || 'Failed to set seller token');
        });
}
async function getbuyerToken() {
    await Axios.get(getAdminUrl(buyertoken), getAdminHeaders())
        .then(response => {
            store.dispatch({
                type: 'SET_BUYER_TOKEN',
                payload: response.data['accessToken']
            });
        })
        .catch(error => {
            toast.error(error.response.data['message'] || 'Failed to set seller token');
        });
}

/* set user details to global state from token payload */
export async function setUser(userId = null) {
    try {
        const userFields = ['id', 'firstname', 'lastname', 'url', 'location'];

        if (!userId) {
            const payload = getPayload(ACCESS_TOKEN);
            userId = payload['user'];
            setTokenInterval(payload.exp - payload.iat);
        }

        await Axios.post(getAdminUrl(`${admindetail}/${userId}`), { field: userFields }, getAdminHeaders())
            .then(response => {
                store.dispatch({
                    type: 'SET_USER',
                    payload: {
                        id: response.data['data'][0]['id'],
                        firstName: response.data['data'][0]['firstname'],
                        lastName: response.data['data'][0]['lastname'],
                        profileImage: response.data['data'][0]['url'],
                        roleid: response.data['data'].map(el => el['roleid']),
                        role: response.data['data'].map(el => el['role']),
                        locationid: response.data['data'].map(el => el['locationid'])
                    }
                });
            });
    } catch (error) {
        // toast.error('Failed to set user');
    }
}

/* checks where user is authenticated by validating token */
export async function isAuthenticated(history) {
    let value = history.location.pathname
    store.dispatch({ type: 'urlNavigate', payload: value });
    if (!isTokenExpired(REFRESH_TOKEN)) {
        await tokenRefresh();
        await getSellerToken();
        await getbuyerToken();
        await setUser();
    } else {
        if (getToken(REFRESH_TOKEN)) {
            store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
            // logout(history);
        }
    }
}

/* checks whether a valid token is available */
export function isAuthorized(logoutUser = false) {
    let userLogin = getToken(ACCESS_TOKEN) ? true : false;

    if (logoutUser && userLogin) {
        logout(null, false);
        userLogin = false;
    }

    return userLogin;
}

/* set interval to update access token */
async function setTokenInterval(interval) {
    let intervalMs = (interval - 300) * 1000;
    const intervalId = setInterval(tokenRefresh, intervalMs);

    await store.dispatch({ type: 'SET_REFRESH', payload: intervalId });
}

/* api call to fetch new access token */
export async function tokenRefresh() {
    const headers = {
        'Authorization': `Bearer ${getToken(REFRESH_TOKEN)}`,
        'Content-Type': 'application/json'
    };

    await Axios.get(getAdminUrl(tokenrefresh), { headers: headers })
        .then(response => {
            setAccessToken(response.data['newToken']);
        })
        .catch(error => {
            const statusCode = error?.response?.status;
            if (!error?.response) {
                return;
            }
            if (statusCode === 401 ) {
                logout(createBrowserHistory());
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
            }
        });
}